export const HIJACK_LINK = '/hijack/acquire/'
